import { ApiListResponse, ApiResponse } from "@/types/api-response.model";
import { LeaveBalance, CreateLeaveDto, LeaveData, LeaveTypes } from "@/types/leave.interfaces";
import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class LeaveService {
  private http = inject(HttpClient);
  private readonly apiUrl = `/api/leaves`;

  getLeaves(): Observable<ApiListResponse<LeaveData>> {
    return this.http.get<ApiListResponse<LeaveData>>(this.apiUrl);
  }

  getLeaveById(id: string): Observable<ApiResponse<LeaveData>> {
    return this.http.get<ApiResponse<LeaveData>>(`${this.apiUrl}/${id}`);
  }

  getLeaveBalance(employeeId: string): Observable<ApiResponse<LeaveBalance>> {
    return this.http.get<ApiResponse<LeaveBalance>>(`${this.apiUrl}/balance/${employeeId}`);
  }

  getLeaveTypes(employeeId: string): Observable<ApiListResponse<LeaveTypes>> {
    return this.http.get<ApiListResponse<LeaveTypes>>(`${this.apiUrl}/types/${employeeId}`);
  }

  getLeaveHistory(employeeId: string): Observable<ApiListResponse<any>> {
    return this.http.get<ApiListResponse<any>>(`${this.apiUrl}/history/${employeeId}`);
  }

  getEmployees(): Observable<ApiListResponse<any>> {
    return this.http.get<ApiListResponse<any>>(`/api/employee?page=1&size=1000&isActive=true`);
  }

  updateLeaveType(id: string, leaveType: string, remaining: number, reason: string): Observable<ApiResponse<any>> {
    return this.http.patch<ApiResponse<any>>(`${this.apiUrl}/settings/${id}`, {
      // type: leaveType,
      remaining,
      reason
    });
  }


  createLeave(payload: CreateLeaveDto): Observable<ApiResponse<LeaveData>> {
    return this.http.post<ApiResponse<LeaveData>>(this.apiUrl, payload);
  }

  updateLeave(id: string, payload: Partial<CreateLeaveDto>): Observable<ApiResponse<LeaveData>> {
    return this.http.patch<ApiResponse<LeaveData>>(`${this.apiUrl}/${id}`, payload);
  }

  approveLeave(id: string): Observable<ApiResponse<LeaveData>> {
    return this.http.patch<ApiResponse<LeaveData>>(`${this.apiUrl}/${id}/approve`, {});
  }

  rejectLeave(id: string): Observable<ApiResponse<LeaveData>> {
    return this.http.patch<ApiResponse<LeaveData>>(`${this.apiUrl}/${id}/reject`, {});
  }

  cancelLeave(id: string): Observable<ApiResponse<LeaveData>> {
    return this.http.patch<ApiResponse<LeaveData>>(`${this.apiUrl}/${id}/cancel`, {});
  }
}
